import { useCallback, useLayoutEffect } from 'react';

import { useNavigate } from '@tanstack/react-router';

import { useAuthTokenListener } from '@/_providers/auth-provider/use-auth-token-listener';
import { CookieManager } from '@/_shared';

export function useLoginLayout() {
  const nav = useNavigate();

  const redirectIfAuthenticated = useCallback(() => {
    if (CookieManager.isLoggedIn()) {
      nav({ to: '/dashboard' });
    }
  }, [nav]);

  useLayoutEffect(() => {
    redirectIfAuthenticated();
  }, [redirectIfAuthenticated]);

  useAuthTokenListener({
    onAuthenticated: redirectIfAuthenticated,
    onUnauthenticated: () => undefined,
  });
}
